export enum EServiceType {
  /** Спрос */
  demand = 'demand',
  /** Бесплатная публикация */
  free = 'free',
  /** Платная публикация */
  paid = 'paid',
  /** Премиум публикация */
  premium = 'premium',
  /** Пакет заявок */
  demandPackage = 'demandPackage',
  /** Колтрекинг */
  calltracking = 'calltracking',
  /** Аукцион */
  auction = 'auction',
  /** Топ */
  top3 = 'top3',
  /** Выделение цветом */
  highlight = 'highlight',
  /** Подписка как VAS */
  servicePackage = 'servicePackage',
}
